import { ref } from 'vue';

export function useDragDrop(onFilesDropped: (files: File[]) => void) {
  const dragOver = ref(false);

  function onDragOver(e: DragEvent) {
    e.preventDefault();
    dragOver.value = true;
  }

  function onDragLeave(e: DragEvent) {
    e.preventDefault();
    dragOver.value = false;
  }

  function onDrop(e: DragEvent) {
    e.preventDefault();
    dragOver.value = false;
    
    const files = Array.from(e.dataTransfer?.files || []);
    if (files.length) {
      onFilesDropped(files);
    }
  }

  return {
    dragOver,
    onDragOver,
    onDragLeave,
    onDrop,
  };
}